import type { ChangeEvent } from "react";
import { m } from "@/paraglide/messages";
import { getLocale, locales, setLocale } from "@/paraglide/runtime";

// Keys must match locale codes in project.inlang/settings.json
const LOCALE_DISPLAY: Record<string, { flag: string; label: string }> = {
  en: { flag: "🇺🇸", label: "English" },
  es: { flag: "🇲🇽", label: "Español" },
  de: { flag: "🇩🇪", label: "Deutsch" },
  nl: { flag: "🇳🇱", label: "Nederlands" },
  fr: { flag: "🇫🇷", label: "Français" },
  it: { flag: "🇮🇹", label: "Italiano" },
  "pt-BR": { flag: "🇧🇷", label: "Português (BR)" },
  pt: { flag: "🇵🇹", label: "Português" },
  ja: { flag: "🇯🇵", label: "日本語" },
  zh: { flag: "🇨🇳", label: "中文" },
};

export default function LocaleSwitcher() {
  const currentLocale = getLocale();

  function handleChange(e: ChangeEvent<HTMLSelectElement>) {
    setLocale(e.target.value as (typeof locales)[number]);
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground">
        {m.footer_language()}
      </span>
      <select
        value={currentLocale}
        onChange={handleChange}
        className="text-xs bg-transparent border border-border rounded px-2 py-1 text-muted-foreground hover:text-foreground hover:border-border/80 transition-colors cursor-pointer focus:outline-none focus:ring-1 focus:ring-ring"
        aria-label={m.footer_language()}
      >
        {locales.map((locale) => {
          const display = LOCALE_DISPLAY[locale] ?? {
            flag: "🌐",
            label: locale,
          };
          return (
            <option key={locale} value={locale}>
              {display.flag} {display.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
